"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersectionInit = exports.handleMoney = void 0;
/* eslint-disable @typescript-eslint/no-magic-numbers */
const utils_1 = require("./utils");
const isEN = (0, utils_1.useIsEN)();
const isJP = (0, utils_1.useIsJP)();
const isHK = (0, utils_1.ueseIsHK)();
const handleMoney = (numori) => {
    let ret = 0;
    const miuns = numori < 0;
    const num = Math.abs(numori);
    if (isEN) {
        if (num >= 1e9) {
            // ret = Math.floor(num * 1e2 / 1e9) / 1e2;
            ret = `${(Math.floor(num / 1e7) / 1e2).toFixed(2)}B`;
        }
        else if (num >= 1e6) {
            // ret = Math.floor(num * 1e2 / 1e6) / 1e2;
            ret = `${(Math.floor(num / 1e4) / 1e2).toFixed(2)}M`;
        }
        else {
            // ret = Math.floor(num * 1e2 / 1e3) / 1e2;
            ret = `${(Math.floor(num / 10) / 1e2).toFixed(2)}K`;
        }
    }
    else if (num >= 1e8) {
        // ret = Math.floor(num * 1e2 / 1e8) / 1e2;
        const unit = isJP || isHK ? '億' : '亿';
        ret = `${(Math.floor(num / 1e6) / 1e2).toFixed(2)}${unit}`;
    }
    else {
        // ret = Math.floor(num * 1e2 / 1e4) / 1e2;
        ret = `${(Math.floor(num / 1e2) / 1e2).toFixed(2)}万`;
    }
    if (miuns) {
        return `-${ret}`;
    }
    return ret;
};
exports.handleMoney = handleMoney;
/**
 * 到视区再加载函数
 * @param {Object} el 视区节点
 * @param {String} fn 初始化数据
 * @param {Object} inited 数据是否已经加载
 * @returns void
 */
const intersectionInit = (el, fn, inited) => {
    try {
        const observer = new IntersectionObserver((IoEntity) => {
            const isShow = (IoEntity || []).find((item) => item.intersectionRatio > 0);
            // intersectionRatio目标元素的可见比例，完全可见时为1，完全不可见时小于等于0
            if (isShow && !inited.value) {
                fn();
            }
        });
        observer.observe(el);
    }
    catch (error) {
        fn();
    }
};
exports.intersectionInit = intersectionInit;
//# sourceMappingURL=data:application/json;base64,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